import { Role } from 'auth';
import dayjs from 'dayjs';
import { withPrivateAccess } from '@/modules/auth/hocs/withPrivateAccess.tsx';
import { useCurrentUserQuery } from '@/modules/auth/queries/user.tsx';
import CommonStatistic from '@/modules/common/components/dashboard/CommonStatistic.tsx';
import { Meetings } from '@/modules/common/components/dashboard/Meetings.tsx';
import TaskCompletionComparison from '@/modules/common/components/dashboard/TaskCompletionComparison.tsx';
import TasksOverview from '@/modules/common/components/dashboard/TasksOverview.tsx';
import UpcomingTasks from '@/modules/common/components/dashboard/UpcomingTasks.tsx';
import { useTasksMonthStatisticQuery } from '@/modules/common/queries/tasks.ts';
// import Reports from '@/modules/employee-dashboard/components/dashboard/Reports.tsx';
import { employeeDashboardPaths } from '@/modules/employee-dashboard/routes.tsx';
import { PageLayout } from 'ui';

const Dashboard = () => {
  const { data } = useCurrentUserQuery();

  const { data: lastMonthData, isLoading: isLoadingLastMonthData } = useTasksMonthStatisticQuery({
    from_date: dayjs().startOf('month').format('YYYY-MM-DD'),
    to_date: dayjs().endOf('month').format('YYYY-MM-DD'),
  });

  return (
    <PageLayout
      title={<div className="text-[32px] font-semibold">Hello, {data?.user?.first_name}</div>}
      headerBottomContent={
        <TaskCompletionComparison isLoading={false} pivotStatistic={undefined} />
      }
      headerClassname="!border-none"
    >
      <div className="flex flex-col gap-6">
        <CommonStatistic data={lastMonthData} isDataLoading={isLoadingLastMonthData} />
        <div className="grid gap-6 w-full grid-cols-1 lg:grid-cols-2">
          <Meetings />
          <UpcomingTasks viewAllPath={employeeDashboardPaths.static.tasks} />
          {/* <Reports /> */}
        </div>
        <TasksOverview />
      </div>
    </PageLayout>
  );
};

export default withPrivateAccess(Dashboard, Role.COMPLIANCE_USER);
